module.exports = __webpack_public_path__ + "static/assets/0c79a4dc1d3bd4c0953289a08f5b8384.svg";